/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { connect } from 'react-redux';

import { Messages } from './Messages';

/**
 * this page is used to list messages
 * 
 * @param props
 * 
 * @returns html code to render the message list
 * 
**/

class MessageReplied extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Messages {...this.props} />
        );
    }
}

export default connect(state => state)(MessageReplied);